module.exports = __webpack_public_path__ + "static/energy_2-85cc0053f780cdd2ed054cf6205371ef.jpg";